<template>
    <v-app :key="localeKey">
        <app-drawer :menus.sync="menus" :drawer.sync="drawer" class="shidden-md-and-up"></app-drawer>

        <app-bar :menus="menus" :drawer.sync="drawer"></app-bar>

        <v-content>
            <div class="page-wrapper">
                <v-container fluid>
                    <page-header v-if="$route.meta.breadcrumb" :menus.sync="menus"></page-header>
                    <router-view></router-view>
                </v-container>
            </div>
        </v-content>

        <footer-bar></footer-bar>
        <app-fab></app-fab>
    </v-app>
</template>

<script>
import Firebase from '@/plugins/firebase'
import { setUserProperties } from 'firebase/analytics'
import Parse from 'parse'
import AppDrawer from '@/components/AppDrawer.vue'
import AppBar from '@/components/AppBar.vue'
import PageHeader from '@/components/PageHeader'
import FooterBar from '@/components/FooterBar.vue'
import AppFab from '@/components/AppFab'
import API from '@/api'

export default {
    name: 'default-layout',
    components: {
        AppDrawer,
        AppBar,
        PageHeader,
        FooterBar,
        AppFab
    },
    data () {
        return {
            drawer: null,
            liveQuery: false,
            loading: false,
            menus: [],
            localeKey: 0
        }
    },
    mounted () {
        this.setup()
    },
    methods: {
        async setup () {
            this.returnMenus()
            if (window.getApp.isEmployee && !this.liveQuery) {
                await this.getNewNotifications()
                this.initLivequery()
            }
            this.initFirebase()
        },
        getCurrentUserCompany () {
            return JSON.parse(localStorage.getItem('currentUserCompany'))
        },
        returnMenus () {
            const currentUserCompany = this.getCurrentUserCompany()
            const menus = {
                company: [
                    { index: 1, title: this.$t('labels.demands'), group: 'menu', icon: 'gavel', name: 'Demandas', isEmployee: false, clientOnly: false, isMainAccount: false },
                    { index: 2, title: this.$t('labels.contracts'), group: 'menu', icon: 'description', name: 'Contratos', isEmployee: false, clientOnly: false, isMainAccount: false },
                    { index: 3, title: this.$t('labels.corporate'), group: 'menu', icon: 'group_work', name: 'Societario', isEmployee: true, clientOnly: false, isMainAccount: false },
                    { index: 4, title: this.$t('labels.brands'), group: 'menu', icon: 'collections', name: 'Marcas', isEmployee: true, clientOnly: false, isMainAccount: false },
                    { index: 5, title: this.$t('labels.departments'), group: 'menu', icon: 'business', name: 'Departamentos', isEmployee: true, clientOnly: false, isMainAccount: false, isManager: false },
                    { index: 6, title: this.$t('labels.teamMembers'), group: 'menu', icon: 'person', name: 'Colaboradores', isEmployee: false, clientOnly: true, isMainAccount: true },
                    { index: 7, title: this.$t('labels.legalTeam'), group: 'menu', icon: 'person', name: 'Staff', isEmployee: true, clientOnly: false, isMainAccount: false },
                    { index: 8, title: this.$t('labels.notifications'), group: 'menu', icon: 'notification_important', name: 'Notificacoes', isEmployee: true, clientOnly: false, isMainAccount: false, badge: { value: 0 } }
                ],
                manager: [
                    { index: 1, title: this.$t('labels.demands'), group: 'menu', icon: 'gavel', name: 'Demandas', isEmployee: false, clientOnly: false, isMainAccount: false },
                    { index: 2, title: this.$t('labels.contracts'), group: 'menu', icon: 'description', name: 'Contratos', isEmployee: false, clientOnly: false, isMainAccount: false },
                    { index: 3, title: this.$t('labels.corporate'), group: 'menu', icon: 'group_work', name: 'Societario', isEmployee: true, clientOnly: false, isMainAccount: false },
                    { index: 4, title: this.$t('labels.brands'), group: 'menu', icon: 'collections', name: 'Marcas', isEmployee: true, clientOnly: false, isMainAccount: false },
                    { index: 5, title: this.$t('labels.portfolios'), group: 'menu', icon: 'contacts', name: 'Portfolios', isManager: true, isEmployee: true, clientOnly: false, isMainAccount: false },
                    { index: 6, title: this.$t('labels.departments'), group: 'menu', icon: 'business', name: 'Departamentos', isManager: true, isEmployee: true, clientOnly: false, isMainAccount: false },
                    { index: 7, title: this.$t('labels.teamMembers'), group: 'menu', icon: 'person', name: 'Colaboradores', isEmployee: false, clientOnly: true, isMainAccount: true },
                    { index: 8, title: this.$t('labels.legalTeam'), group: 'menu', icon: 'person', name: 'Staff', isEmployee: true, clientOnly: false, isMainAccount: false },
                    { index: 9, title: this.$t('labels.notifications'), group: 'menu', icon: 'notification_important', name: 'Notificacoes', isEmployee: true, clientOnly: false, isMainAccount: false, badge: { value: 0 } }
                ],
                department: [
                    { index: 1, title: this.$t('labels.demands'), group: 'menu', icon: 'gavel', name: 'Demandas', isEmployee: false, clientOnly: false, isMainAccount: false },
                    { index: 2, title: this.$t('labels.contracts'), group: 'menu', icon: 'description', name: 'Contratos', isEmployee: false, clientOnly: false, isMainAccount: false },
                    { index: 7, title: this.$t('labels.teamMembers'), group: 'menu', icon: 'person', name: 'Colaboradores', isEmployee: false, clientOnly: true, isMainAccount: true }
                ]
            }

            if (['qNWioLIdD1', 'INbNJV2NNI'].includes(currentUserCompany.client.objectId)) {
                menus.manager.unshift({ index: 0, title: this.$t('labels.dashboard'), group: 'menu', icon: 'dashboard', name: 'Dashboard', isEmployee: true, clientOnly: false, isMainAccount: false })
            }

            const permissions = currentUserCompany.client.permissions

            if (permissions !== undefined) {
                if ('brands' in permissions) {
                    this.menus = [
                        { index: 0, title: this.$t('labels.brands'), group: 'menu', icon: 'collections', name: 'Marcas', isEmployee: false, clientOnly: false, isMainAccount: false }
                    ]
                }
            } else {
                this.menus = [...menus[currentUserCompany.client.type === 'managed_company' ? 'company' : currentUserCompany.client.type]]
            }
        },
        async getNewNotifications (notification = null) {
            const currentUserCompany = this.getCurrentUserCompany()
            const params = { organizationId: currentUserCompany.client.objectId }

            try {
                const response = await new API(API.EndPoints.getNewNotifications, params).request()
                this.updateNotificationBadge(response.body.result.totalNotification)
                this.$root.notifications = response.body.result
                this.$root.newNotification = true
                if (notification && notification.id) {
                    this.$root.notificationId = notification.id
                }
            } finally {
                this.loading = false
            }
        },
        updateNotificationBadge (totalNotifications) {
            const notificationsMenu = this.menus.find(menu => menu.index === 9)
            if (notificationsMenu) {
                notificationsMenu.badge.value = totalNotifications.toString()
            }
        },
        async initLivequery () {
            const user = JSON.parse(localStorage.profile)
            const currentUserCompany = JSON.parse(localStorage.currentUserCompany)
            const queryUser = new Parse.Query('Notification')
            queryUser.containsAll('postTo', [currentUserCompany.objectId])
            queryUser.notContainedIn('itWasRead', [currentUserCompany.objectId])

            // verificar
            const queryDistribution = new Parse.Query('Notification')
            queryDistribution.containsAll('postTo', [currentUserCompany.distributionId])
            queryDistribution.notContainedIn('itWasRead', [currentUserCompany.objectId])

            var query = Parse.Query.or(queryDistribution, queryUser)

            this.livequerySubscription = await query.subscribe(user.sessionToken)

            this.livequerySubscription.on('open', () => {
                this.liveQuery = true
            })

            this.livequerySubscription.on('create', async (notification) => {
                await this.getNewNotifications(notification)
                this.$root.newNotification = true
            })

            this.livequerySubscription.on('update', async (notification) => {
                if (this.loading === false) {
                    this.loading = true
                    await this.getNewNotifications(null)
                }
            })

            this.livequerySubscription.on('delete', async (notification) => {
                await this.getNewNotifications(null)
            })
        },
        initFirebase () {
            const currentUserCompany = JSON.parse(localStorage.currentUserCompany)
            setUserProperties(Firebase, { userCompany: currentUserCompany.client.name })
        }
    }
}
</script>

<style lang="stylus" scoped>
    .container
        padding: 30px

    .page-wrapper
        min-height:calc(100vh - 64px - 50px - 81px )
</style>
